const topicTags = [
  { name: '最新电影大全', hot: '128万', icon: 'ri-fire-line' },
  { name: '动作片在线', hot: '96万', icon: 'ri-sword-line' },
  { name: '喜剧片免费看', hot: '83万', icon: 'ri-emotion-laugh-line' },
  { name: '科幻片高清', hot: '71万', icon: 'ri-planet-line' },
  { name: '经典电影全集', hot: '65万', icon: 'ri-film-line' },
  { name: '悬疑烧脑', hot: '58万', icon: 'ri-lightbulb-line' },
  { name: '4K超清专区', hot: '52万', icon: 'ri-4k-line' },
  { name: '国产佳片', hot: '47万', icon: 'ri-flag-2-line' },
  { name: '好莱坞大片', hot: '44万', icon: 'ri-global-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          大家都在讨论的电影话题，看看有没有你感兴趣的
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag) => (
            <div
              key={tag.name}
              className="group cursor-default bg-background-50 border border-background-200/60 rounded-full px-5 py-2.5 flex items-center gap-2.5 hover:border-primary-500/40 transition-colors"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${tag.icon} text-accent-500 text-sm`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{tag.name}</span>
              <span className="text-xs text-foreground-400 font-mono">{tag.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}